import { render } from "./HbMenu.vue?vue&type=template&id=1b3cabe6"
import script from "./HbMenu.vue?vue&type=script&lang=js"
export * from "./HbMenu.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herrera/proyectos/sacvi3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__